/* eslint-disable import/no-cycle */
import api from './api.service';

function currentUser() {
  return api.get('/auth/sessions');
}

function index(params) {
  return api.get('/users/', params);
}

function get(id, params) {
  return api.get(`/users/${id}`, params);
}

function create(params) {
  return api.post('/users', params);
}

function update(id, params) {
  return api.put(`/users/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/users/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function getUserPermission(param) {
  return api.get('/perms', param);
}

export const usersService = {
  currentUser,
  index,
  get,
  create,
  update,
  remove,
  save,
  getUserPermission,
};
